import { render, staticRenderFns } from "./DetailTopNav.vue?vue&type=template&id=60222b12&scoped=true&"
import script from "./DetailTopNav.vue?vue&type=script&lang=js&"
export * from "./DetailTopNav.vue?vue&type=script&lang=js&"
import style0 from "./DetailTopNav.vue?vue&type=style&index=0&id=60222b12&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60222b12",
  null
  
)

export default component.exports